import React, { useRef, useState, useContext } from "react";
import { Modal, Button, Row, Col } from "react-bootstrap";
import Webcam from "react-webcam";
import axios from "axios";
import PermissionContext from "../../../Store/permission-context";

const UploadInvoiceModal = (props) => {
  const [ShowModal, setShowModal] = useState(props.showmodal);
  const [Error, setError] = useState("");
  const PCtx = useContext(PermissionContext);
  const webcamRef = useRef(null);
  const [ImageSrc, setImageSrc] = useState(null);

  const cancelM = () => {
    setShowModal(false);
    props.cancelModal();
  };

  const capture = () => {
    const ImageSrc = webcamRef.current.getScreenshot();
    setImageSrc(ImageSrc);
  };

  const dataURItoBlob = (dataURI) => {
    const byteString = atob(dataURI.split(",")[1]);
    const mimeString = dataURI.split(",")[0].split(":")[1].split(";")[0];
    const ab = new ArrayBuffer(byteString.length);
    const ia = new Uint8Array(ab);
    for (let i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }
    return new Blob([ab], { type: mimeString });
  };

  const saveTheInvoice = () => {
    let fmdata = new FormData();
    ImageSrc != null &&
      fmdata.append("pictureSelected1", dataURItoBlob(ImageSrc), ImageSrc.name);

    axios({
      method: "post",
      url: "applauseinfotech/phpfiles/uploadinvoice.php",
      headers: {
        "Content-type": "multipart/form-data",
      },
      data: fmdata,
    })
      .then((result) => {
        var dat = result.data;

        if (dat != "Error") {
          setShowModal(false);
          props.cancelModal();
          props.setInvoicePix(dat);
          PCtx.displayAlert(
            "Invoice Uploaded",
            "The Invoice has been successfully uploaded",
            "success",
          );
        }
      })

      .catch((error) => setError(error.message));
    console.log(Error);
  };

  return (
    ShowModal && (
      <Modal
        show={ShowModal}
        onHide={cancelM}
        backdrop="static"
        keyboard={false}
        style={{ fontFamily: "Times New Roman", color: "brown" }}
      >
        <Modal.Header closeButton>
          <Modal.Title style={{ color: "brown" }}>UPLOAD INVOICE</Modal.Title>
        </Modal.Header>
        <Modal.Body
          style={{
            fontFamily: "Times New Roman",
          }}
        >
          <Webcam screenshotFormat="image/jpeg" audio={false} ref={webcamRef} />
          <Row>
            <Col md={6}>
              <Button variant="success" onClick={capture}>
                Capture photo
              </Button>
            </Col>
            <Col md={6}>
              {ImageSrc && (
                <Button variant="success" onClick={saveTheInvoice}>
                  Save Invoice
                </Button>
              )}
            </Col>
          </Row>
          {ImageSrc && <img src={ImageSrc} />}
        </Modal.Body>
      </Modal>
    )
  );
};

export default UploadInvoiceModal;
